<template>
  <nav class="navbar navbar-default navbar-pf" role="navigation">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse-1">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar" />
        <span class="icon-bar" />
        <span class="icon-bar" />
      </button>
      <span class="navbar-brand">
        <strong>KMITL</strong> OSDA Event Management System
      </span>
    </div>
    <div class="collapse navbar-collapse navbar-collapse-1">
      <ul class="nav navbar-nav navbar-utility">
        <li class="dropdown">
          <button id="horizontalDropdownMenu11" class="btn btn-link nav-item-iconic" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="true"
          >
            <span title="Help" class="fa pficon-help dropdown-title" />
          </button>
          <ul class="dropdown-menu" aria-labelledby="horizontalDropdownMenu11">
            <li><a href="#">คู่มือการใช้งาน</a></li>
            <li><a href="#" data-toggle="modal" data-target="#about-modal">เกี่ยวกับโปรแกรม</a></li>
          </ul>
        </li>

        <li class="dropdown">
          <button class="btn btn-link dropdown-toggle" data-toggle="dropdown">
            <span class="pficon pficon-user" />
            <span class="dropdown-title">{{ $auth.user().firstName + ' ' + $auth.user().lastName }} (ระดับ: {{ role }}) <b class="caret" /></span>
          </button>
          <ul class="dropdown-menu">
            <li><a href="#0">เปลี่ยนรหัสผ่าน</a></li>
            <li class="divider" />
            <li><a href="#" @click.prevent="logout">ออกจากระบบ</a></li>
          </ul>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-primary">
        <!-- <li>
          <a href="/">หน้าแรก</a>
        </li> -->
        <router-link tag="li" :to="{ name: 'projects.index' }" active-class="active" :class="{ active: $route.path.match('/projects*') }">
          <a href="#">โครงการ</a>
        </router-link>
        <router-link v-if="userType == 'osda'" tag="li" :to="{ name: 'settings.groups.index' }" active-class="active" :class="{ active: $route.path.match('/settings*') }">
          <a href="#">ตั้งค่าระบบ</a>
        </router-link>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    userType () {
      return this.$auth.user().role
    },
    role () {
      switch (this.userType) {
        case 'student':
          return 'ผู้ประสานงาน'
        case 'advisor':
          return 'อาจารย์ที่ปรึกษา'
        case 'osda':
          return 'เจ้าหน้าที่องค์การนักศึกษา'
      }

      return ''
    }
  },
  methods: {
    logout () {
      this.$auth.logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/shared/NavigationBar.vue